/**
 * Remove a Track from the connection.
 * @method removeTrack
 * @param  {string} trackId An id for a Track object.
 */
export default function removeTrack (trackId) {
  const { nativePeer, proxyPeer, log } = this
  log.info(`Removing track ${trackId}.`)

  const track = proxyPeer.senderTracks.find(track => track.id === trackId)
  if (!track) {
    log.info(`Invalid track ID ${trackId}; no such track found.`)
    return
  } else if (proxyPeer.signalingState === ' closed') {
    log.info('Peer is closed; cannot remove track.')
    return
  }

  // Get the RtpSender for the Track we want to remove.
  const sender = proxyPeer
    .getSenders()
    .filter(sender => sender.track !== null)
    .find(sender => sender.track.id === trackId)
  nativePeer.removeTrack(sender)
}
